import { useState } from 'react';

import { AccountSlot } from '../../Mobile/Account';
import { LoginDialog } from '../../../../LoginDialog/LoginDialog';

export const AccountTabContent = () => {
  const [showLoginModal, setShowLoginModal] = useState(false);

  return (
    <div className="flex flex-col overflow-y-auto overscroll-contain [grid-area:content]">
      <AccountSlot onLogin={() => setShowLoginModal(true)} />
      <LoginDialog
        open={showLoginModal}
        handleClose={() => setShowLoginModal(false)}
        onClose={() => setShowLoginModal(false)}
      />
    </div>
  );
};
